import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./styles/header.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as outlineHeart } from "@fortawesome/free-regular-svg-icons"; // Outlined heart
import {
  faShoppingCart,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { useGetCartCountQuery } from "../../services/cartPageAPI";
import { useGetColorThemeQuery } from "../../services/commonAPI";
import DefaultLogo from "../../assets/images/default-logo.png"
import { useGetFooterContentQuery } from '../../services/commonAPI';
import { useRefreshTokenMutation } from "../../services/myAccountAPI";
import Loader from "../pages/fullPageLoader"

function Header() {
  const navigate = useNavigate();
  // const pathname = useLocation();

  const [submitRefreshToken, { isError: isErrorRefreshToken }] =
    useRefreshTokenMutation();


  const handleSubmitRefreshToken = useCallback(async () => {
    const refreshToken = localStorage.getItem("refresh_token");
    if (!refreshToken) return;

    let postData = { refresh: refreshToken };

    try {
      const response = await submitRefreshToken(postData).unwrap();
      localStorage.setItem("access_token", response.access_token);
      localStorage.setItem("refresh_token", response.refresh_token);
    } catch (err) {

      navigate("/login");
    }
  }, [navigate, submitRefreshToken]);


  const currentAccessToken = localStorage.getItem("access_token");
  useEffect(() => {
    if (isErrorRefreshToken) {
      navigate("/login");
      localStorage.clear();
    }
  }, [isErrorRefreshToken, navigate])

  useEffect(() => {
    if (currentAccessToken) {
      const intervalId = setInterval(() => {
        handleSubmitRefreshToken();
      }, 50000);

      return () => clearInterval(intervalId);
    }
  }, [currentAccessToken, handleSubmitRefreshToken]);

  const {
    data,
    refetch
  } = useGetCartCountQuery();

  const {
    data: footerContent,
    error: footerContentError,
    isLoading: footerContentLoading,
  } = useGetFooterContentQuery();

  const {
    data: colorthemeData,
  } = useGetColorThemeQuery();


  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const accessToken = localStorage.getItem("access_token");
  const userId = localStorage.getItem("gridMarker");

  const handleUserIconClick = (e) => {
    e.preventDefault(); // Prevent default link behavior

    // Check if the user is logged in
    if (accessToken && userId) {
      // User is logged in, navigate to /my-account
      navigate("/my-account");
    } else {
      // User is not logged in, navigate to /login
      navigate("/login");
    }
  };

  useEffect(() => {
    refetch();
  }, [refetch])

//   useEffect(() => {
//     const logoutTime = 6 * 60 * 60 * 1000;

//     const logout = () => {
//         localStorage.clear();
//         navigate("/login");
//     };

//     const storedTime = localStorage.getItem("loginTime");
//     const currentTime = new Date().getTime();

//     if (storedTime && currentTime - storedTime > logoutTime) {
//         logout();
//     } else {
//         const timer = setTimeout(logout, logoutTime - (currentTime - storedTime));
//         return () => clearTimeout(timer);
//     }
// }, [navigate]);


  const footerSecContent = footerContent?.data?.[0];

  if (footerContentLoading) return <Loader />;
  if (footerContentError) return <p>Failed to load data</p>;

  return (
    <header>
      {(footerSecContent?.header_text_one || footerSecContent?.header_text_two || footerSecContent?.header_text_three || footerSecContent?.header_text_four) && (
        <div
          className="primary-menu"
          style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}
        >
          <div className="row align-items-center place-content-center">
            {footerSecContent?.header_text_one && (
              <div className="col-md-3 col-sm-3">
                <p className="m-0 p-0">{footerSecContent?.header_text_one}</p>
              </div>
            )}
            {footerSecContent?.header_text_two && (
              <div className="col-md-3 col-sm-3">
                <p className="m-0 p-0">{footerSecContent?.header_text_two}</p>
              </div>
            )}
            {footerSecContent?.header_text_three && (
              <div className="col-md-3 col-sm-3">
                <p className="m-0 p-0">{footerSecContent?.header_text_three}</p>
              </div>
            )}
            {footerSecContent?.header_text_four && (
              <div className="col-md-3 col-sm-3">
                <p className="m-0 p-0">{footerSecContent?.header_text_four}</p>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="secondary-menu">
        <div className="container-fluid">
          <div className="row">

            <div className="col-md-9 col-sm-12">

              <div className="mobile-header">
                <div className="d-flex justify-space-between">
                  <div className="mobile-header-icons">
                    <div className="icons-wrapper d-flex gap-10">
                      <Link to="#" onClick={handleUserIconClick} title={accessToken && userId ? "My Account" : "Login"}>
                        <FontAwesomeIcon
                          icon={faUser}
                          style={{
                            color: "transparent",
                            stroke: "black",
                            strokeWidth: "20px",
                          }}
                        />
                      </Link>
                      <div className="wish-list-icon">
                        <div className="wish-list-count" style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>{data?.wishlist_count || 0}</div>
                        <Link to="/wishlist">
                          <FontAwesomeIcon icon={outlineHeart} className="whish-list-icon" />
                        </Link>
                      </div>

                      <div className="gap-border"></div>
                      <div className="add-to-cart-icon">
                        <div className="cart-count" style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>{data?.data || 0}</div>
                        <Link to="/cart-page">
                          <FontAwesomeIcon
                            icon={faShoppingCart}
                            style={{
                              color: "transparent",
                              stroke: "black",
                              strokeWidth: "20px",
                            }}
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`menu-tigger ${isMenuOpen ? "button-tigger" : ""}`}
                    onClick={toggleMenu}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                {/* Icons Wrapper */}

              </div>

              <nav className={isMenuOpen ? "res-menu" : ""}>
                <ul>
                  <li onClick={toggleMenu}>
                    <a href="/">
                      <img src={colorthemeData?.color_themes[0]?.main_logo_url || DefaultLogo} width={200} height={50} alt="Logo" className="logo"  loading="lazy"/>
                    </a>
                  </li>
                  <li onClick={toggleMenu}>
                    <Link to="/">Home</Link>
                  </li>
                  <li onClick={toggleMenu}>
                    <Link to="/about">About</Link>
                  </li>
                  <li onClick={toggleMenu}>
                    <Link to="/shop">Shop</Link>
                  </li>
                  <li onClick={toggleMenu}>
                    <Link to="/contact">Contact</Link>
                  </li>

                </ul>
              </nav>
            </div>
            <div className="col-md-3 col-sm-3">
              <div className="right-div">
                <Link
                  to="#"
                  onClick={handleUserIconClick}
                  title={accessToken && userId ? "My Account" : "Login"}
                >
                  <FontAwesomeIcon
                    icon={faUser}
                    style={{
                      color: "transparent",
                      stroke: "black",
                      strokeWidth: "20px",
                    }}
                  />
                </Link>
                <div className="gap-border"></div>
                <div>

                </div>
                <div className="wish-list-icon">
                  <div className="wish-list-count" style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>{data?.wishlist_count || 0}</div>
                  <Link to="/wishlist">
                    <FontAwesomeIcon icon={outlineHeart} className="whish-list-icon" />
                  </Link>
                </div>

                <div className="gap-border"></div>
                <div className="add-to-cart-icon">
                  <div className="cart-count" style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>{data?.data || 0}</div>
                  <Link to="/cart-page">
                    <FontAwesomeIcon
                      icon={faShoppingCart}
                      style={{
                        color: "transparent",
                        stroke: "black",
                        strokeWidth: "20px",
                      }}
                    />
                  </Link>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
